// extracted by mini-css-extract-plugin
export default {"container":"UnregisteredMainContent_container__qQaNP"};